'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useAdpopcorn } from '@/modules/adpopcorn';
import type { MenuItem } from './MenuItems';
interface WelloPointMenuActionItemProps {
  item: MenuItem;
  hasDetailItems: boolean;
  itemClassName: string;
  iconBoxClassName: string;
  iconClassName: string;
  labelClassName: string;
  detailGapClassName: string;
  baseGapClassName: string;
}
export const WelloPointMenuActionItem = t0 => {
  const $ = _c(18);
  const {
    item,
    hasDetailItems,
    itemClassName,
    iconBoxClassName,
    iconClassName,
    labelClassName,
    detailGapClassName,
    baseGapClassName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      placement: "MY_ENTRY"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    status,
    onClick,
    isOpening
  } = useAdpopcorn(t1);
  if (status === "unsupported") {
    return null;
  }
  const t2 = hasDetailItems ? detailGapClassName : baseGapClassName;
  let t3;
  if ($[1] !== itemClassName || $[2] !== t2) {
    t3 = cn(itemClassName, t2, "w-full text-left disabled:opacity-60");
    $[1] = itemClassName;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== hasDetailItems || $[5] !== iconBoxClassName || $[6] !== iconClassName || $[7] !== item.Icon) {
    t4 = hasDetailItems ? <span className={iconBoxClassName}><item.Icon originalFill={true} className={cn(iconClassName, "shrink-0")} /></span> : <item.Icon originalFill={true} className={cn(iconClassName, "shrink-0")} />;
    $[4] = hasDetailItems;
    $[5] = iconBoxClassName;
    $[6] = iconClassName;
    $[7] = item.Icon;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== item.label || $[10] !== labelClassName) {
    t5 = <span className="flex min-w-0 grow flex-col gap-2"><span className={labelClassName}>{item.label}</span></span>;
    $[9] = item.label;
    $[10] = labelClassName;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isOpening || $[13] !== onClick || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <button type="button" onClick={onClick} disabled={isOpening} className={t3}>{t4}{t5}</button>;
    $[12] = isOpening;
    $[13] = onClick;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};